import { render } from "./CommunicationCompose.vue?vue&type=template&id=1769370a"
import script from "./CommunicationCompose.vue?vue&type=script&lang=js"
export * from "./CommunicationCompose.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__